<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'grouping.edit.title.shortLabel' | translate}}
                <app-tooltip text="{{'grouping.edit.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="!isLoading">
        <form [formGroup]="compareGroupForm" (ngSubmit)="onValidate()">
            <mat-form-field>
                <mat-label class="placeholder">
                    {{ 'grouping.edit.form.name.label.shortLabel' | translate }}
                </mat-label>
                <input type="text" matInput formControlName="name">
                <mat-error>{{ 'grouping.edit.form.name.error.summary' | translate }}</mat-error>
            </mat-form-field>

            <div>
                <mat-checkbox name="isPublic" formControlName="isPublic">
                    {{ 'grouping.edit.form.isPublic.shortLabel' | translate }}
                </mat-checkbox>
            </div>

            <app-select-list
                *ngIf="availableOrganisms && availableOrganisms.length"
                [minSelected]="minSelected"
                [availableOrganisms]="availableOrganisms"
                [selectedOrganisms]="selectedOrganisms"
                (selectedOrganismsChanged)="selectedOrganisms = $event"></app-select-list>

            <div class="actions">
                <button mat-raised-button type="submit" color="accent"
                    [disabled]="!compareGroupForm.valid || selectedOrganisms.length < minSelected">
                    <mat-icon aria-label="Validate">check</mat-icon>
                    {{ 'grouping.edit.form.validate.shortLabel' | translate }}
                </button>
                <button mat-button type="button" (click)="onCancel()">
                    <mat-icon aria-label="Cancel">clear</mat-icon>
                    {{ 'grouping.edit.form.cancel.shortLabel' | translate }}
                </button>
            </div>
        </form>
    </mat-card-content>
    <mat-card-content *ngIf="isLoading">
        <mat-spinner [diameter]="35" color="accent"></mat-spinner>
    </mat-card-content>
</mat-card>
